import React from "react";
const EX = [
  {key:"binance",label:"Binance",color:"#f59e0b"},
  {key:"bybit",label:"Bybit",color:"#3b82f6"},
  {key:"okx",label:"OKX",color:"#a855f7"},
  {key:"hyperliquid",label:"Hyperliquid",color:"#06b6d4"},
];
export default function LongShortPanel({ data }) {
  if (!data) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {EX.map(({key,label,color}) => {
        const d = data[key]; if (!d) return null;
        const lp = d.long_pct; const sp = d.short_pct;
        return (
          <div key={key}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:5,alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{width:8,height:8,borderRadius:"50%",background:color,display:"inline-block"}}/>
                <span style={{fontWeight:600,fontSize:13}}>{label}</span>
              </div>
              <div style={{display:"flex",gap:12,fontSize:12}}>
                <span style={{color:"#22c55e",fontWeight:700}}>롱 {lp}%</span>
                <span style={{color:"#ef4444",fontWeight:700}}>숏 {sp}%</span>
                <span style={{padding:"1px 7px",borderRadius:5,fontSize:11,fontWeight:700,
                  background:lp>50?"rgba(34,197,94,.15)":"rgba(239,68,68,.15)",
                  color:lp>50?"#22c55e":"#ef4444"}}>{lp>50?"롱 우세":"숏 우세"}</span>
              </div>
            </div>
            <div style={{display:"flex",height:18,borderRadius:5,overflow:"hidden",background:"#1e2433"}}>
              <div style={{width:`${lp}%`,background:"#22c55e",display:"flex",alignItems:"center",
                justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff",transition:"width .5s"}}>
                {lp>12?`${lp}%`:""}
              </div>
              <div style={{flex:1,background:"#ef4444",display:"flex",alignItems:"center",
                justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff"}}>
                {sp>12?`${sp}%`:""}
              </div>
            </div>
          </div>
        );
      })}
      {data.updated_at&&<p style={{fontSize:11,color:"#374151"}}>{data.updated_at}</p>}
    </div>
  );
}
